/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import styled from '@emotion/styled';
import * as color from '@constant/color';
import { ETheme } from '@datatype/type';
import { IAdminSourceData } from '@datatype/admin/api-type';
import { useAdminSourceQuery } from '@hook/admin/useApi';
import TextBlock from '@component/common/block/text-block';
import TextButton from '@design-system/text-button';
import ExpressionDialogue from '@component/admin/expression/expression-home/expression-preview/expression-dialogue';
import ExpressionReviewModal from '@component/admin/expression/expression-home/expression-preview/expression-review-modal';

interface IProps {
  selectedSource: IAdminSourceData | null;
  handleCreateClick: () => void;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 12px;
  width: 100%;
`;

const TopRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 16px;
  align-items: flex-start;
`;

const VideoBox = styled.div`
  flex: 1;
  height: 300px;
  background-color: ${color.BLACK_2};
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${color.WHITE_1};
`;

const PreviewVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: ${color.BLACK_1};
`;

const ButtonColumn = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  gap: 12px;
  width: 200px;
`;

const ExpressionPreview: React.FC<IProps> = ({ selectedSource, handleCreateClick }) => {
  const sourceQuery = useAdminSourceQuery(selectedSource?.key ?? null);
  const expression = sourceQuery.data?.data?.expression ?? null;
  const [isReviewOpen, setIsReviewOpen] = useState(false);

  return (
    <Wrapper>
      <TopRow>
        <VideoBox>
          {selectedSource?.videoLink ? (
            <PreviewVideo src={selectedSource.videoLink} controls />
          ) : (
            <TextBlock text='영상을 선택하세요' design={{ text: { size: 'medium', color: color.GRAY_2 } }} />
          )}
        </VideoBox>
        <ButtonColumn>
          <TextButton
            text='오늘의표현만들기'
            width='100%'
            handleClick={handleCreateClick}
            disabled={!selectedSource}
          />
          <TextButton
            text='검수결과 보기'
            theme={ETheme.GRAY}
            kind='outlined'
            width='100%'
            handleClick={() => setIsReviewOpen(true)}
            disabled={!expression}
          />
        </ButtonColumn>
      </TopRow>
      {expression && <ExpressionDialogue expression={expression} />}
      <ExpressionReviewModal
        isOpen={isReviewOpen}
        expression={expression}
        onClose={() => setIsReviewOpen(false)}
      />
    </Wrapper>
  );
};

export default ExpressionPreview;
